import { Button, Modal, Typography } from "antd";

const { Paragraph } = Typography;

export type NorthmillIntegrationInfoModalProps = {
  open: boolean;
  onCancel: () => void;
};

export function NorthmillIntegrationInfoModal({ open, onCancel }: NorthmillIntegrationInfoModalProps) {
  return (
    <Modal
      open={open}
      title="Northmill Integration"
      onCancel={onCancel}
      footer={
        <Button type="primary" onClick={onCancel}>
          Stäng
        </Button>
      }
      destroyOnClose
      width={520}
    >
      <Paragraph style={{ marginBottom: 0 }}>
        Här ser du produkter som är kopplade till Northmill Point of Sale och deras respektive synkstatus i integrationen.
        Välj flik för att lista produkter som är synkade, inte synkade, pausade eller misslyckade. Använd filter och
        sök för att begränsa listan. Lagersaldot som synkas till Northmill när artikeln inte är låst är boråsbutikens saldo för respektive artikel.
        <br />
        <br />
        <strong>Synkas</strong>
        <br />
         Produkter som dagligen skickas till Northmill Point of Sale.
        <br />
        <br />
        <strong>Synkas ej</strong>
        <br />
        Produkter som aldrig har blivit synkade.
        <br />
        <br />
        <strong>Pausad</strong>
        <br />
        Produkter som är pausade i integrationen.
        <br />
        <br />
        <strong>Misslyckade</strong>
        <br />
        Produkter som har misslyckats att synkas till Northmill.
        <br />
        <br />
        <strong>Hur låsning fungerar:</strong>
        <br />
        Om du låser en produkt har du möjlighet att ange ett saldo, detta saldo synkas vi låsningstillfället till Northmill. Sedan kommer lagersaldot inte att synkas förrän låset har upphävts. 
        Det pausade lagersaldot kan även inte ändras under tiden då låset är aktivt. Lås upp för att sätta ett nytt lagersaldo.
      </Paragraph>
    </Modal>
  );
}
